var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFaders = function SvgIconFaders(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.75a1 1 0 0 1 1 1v3.125h1.25a1 1 0 1 1 0 2h-4.5a1 1 0 0 1 0-2H11V3.75a1 1 0 0 1 1-1M12 10.625a1 1 0 0 1 1 1v8.625a1 1 0 1 1-2 0v-8.625a1 1 0 0 1 1-1M19.75 19.125a1 1 0 1 0-2 0v1.125a1 1 0 1 0 2 0zM18.75 2.75a1 1 0 0 1 1 1v10.625H21a1 1 0 1 1 0 2h-4.5a1 1 0 1 1 0-2h1.25V3.75a1 1 0 0 1 1-1M5.25 15.125a1 1 0 0 1 1 1v4.125a1 1 0 1 1-2 0v-4.125a1 1 0 0 1 1-1M6.25 3.75a1 1 0 0 0-2 0v7.625H3a1 1 0 1 0 0 2h4.5a1 1 0 1 0 0-2H6.25z"
  }))));
};
export default SvgIconFaders;